export function snip(s?: string, max: number = 16, tail: boolean = true): string {
	if( !s ) return '';
	if( s.length <= max ) return s;
	return s.substring(0, max-(tail? 4:3)) + '...' + (tail? s.charAt(s.length-1) : '');
}

export function snipEmail(email: string, maxUsername: number = 9, maxDomain: number = 15): string {
	if( !email ) return '';
	if( !email.includes('@') ) return email;
	const [username, domain] = email.split('@');
	const truncatedUsername = username.length > maxUsername ? `${username.slice(0, maxUsername)}.` : username;
	const truncatedDomain = domain.length > maxDomain ? `.${domain.slice(-maxDomain)}` : domain;
	return `${truncatedUsername}@${truncatedDomain}`;
}